import { Box } from '@mui/material';
import EmployeeItem from './EmployeeItem';

interface EmployeesProps {
  employees: any[];
  date: any;
}

/**
 * Renders a list of EmployeeItem components, each representing a single employee,
 * with their respective details such as name, identifier number, gender, age, and
 * total contribution amount.
 *
 * @param {EmployeesProps} props - The props for the Employees component.
 * @param {any[]} props.employees - An array of employee objects, each containing
 * information about the employee such as name, identifier number, gender, age,
 * and total contribution amount.
 * @param {any} props.date - The date for which the employee deposits are being displayed.
 *
 * @returns {JSX.Element} A JSX element representing the Employees component.
 */
const Employees: React.FC<EmployeesProps> = ({ employees, date }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {employees.map((employee, index) => (
        <EmployeeItem key={index} employee={employee} date={date} />
      ))}
    </Box>
  );
};

export default Employees;
